module.exports = __webpack_public_path__ + "packs/media/images/pic06-5755b4aae51a9f0dc0fc66baba404824.jpg";